module.exports = __webpack_public_path__ + "img/call_welcome.b056fdfc.png";